import React from "react"
import g from "glamorous"
import Link from "gatsby-link"
//import WorkListItem from "../components/work-list-item.js"
import ProductList from "../components/product-list.jsx"
import { rhythm } from "../utils/typography"
import Footer from "../components/footer.jsx";


export default ({ data }) => {
  return (
    <div>
        <g.H2 display={`none`}>Work</g.H2>
        <ProductList products={ data.allContentfulWork }></ProductList>
    </div>
  )
}

export const query = graphql`
    query homepageWorkList {
        allContentfulWork(limit: 1000, sort: {fields: [releasedDate], order: DESC}) {
            totalCount
            edges {
                node {
                    id
                    title
                    releasedDate
                    photos {
                        description
                        file {
                            url
                        }
                    }
                    fields {
                        slug
                    }
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/index.js